import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route } from 'react-router-dom';
import Root from 'Root';
import './styles/styles.scss';
import App from 'mui-components/App';
import MobileApp from 'mui-mobile-components/App';
import * as serviceWorker from './serviceWorker';
import { isMobileOnly } from 'react-device-detect';

const isStrictMobile = isMobileOnly;

ReactDOM.render(
  <Root>
    <HashRouter>
      {isStrictMobile ? <Route path="/" component={MobileApp} /> : <Route path="/" component={App} />}
    </HashRouter>
  </Root>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
